import React from 'react';
import { FaArrowRightLong } from "react-icons/fa6";
import { MdClose } from "react-icons/md";
const LumpMtrTbl = ({ baleLump, handleDeleteRows, handleLumpAddBale, lumpRows, lumpTotMtr, handleLumpMtr, handleLumpColor, handleLumpSelection, handlePerticularLumpAdd, handleClose }) => {

    return (
        <>
            <div className="lump-content">
                {/* Close Icon */}
                <MdClose className="close-icon" onClick={() => handleClose()} style={{ color: 'black' }} />
                <h3>Lump Details <FaArrowRightLong className="right-arrow" style={{ color: 'black' }} /> {baleLump}</h3>
                <div className="button-group">
                    <button className="add" onClick={() => handlePerticularLumpAdd()}>Add</button>
                    <button className="delete" onClick={() => handleDeleteRows()}>Remove</button>
                </div>
                <table style={{ width: '100%' }}>
                    <thead>
                        <tr>
                            <th>Sr. No.</th>
                            <th>Barcode</th>
                            <th>Color</th>
                            <th>Lump Mtr</th>
                        </tr>
                    </thead>
                    <tbody>
                        {lumpRows?.map((lumpRow, lumpIndex) => (
                            <>
                                <tr key={lumpIndex}>
                                    <td> <input
                                        type="checkbox"
                                        checked={lumpRow.selected}
                                        onChange={() => handleLumpSelection(lumpIndex)}
                                    />{" "}
                                        {lumpIndex + 1}
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="barcode"
                                            value={lumpRow.barcode}
                                            readOnly
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="color"
                                            value={lumpRow.color}
                                            onChange={(e) => handleLumpColor(
                                                lumpIndex,
                                                e.target.value
                                            )}
                                        />
                                    </td>
                                    <td>
                                        <input
                                            type="text"
                                            placeholder="Lump Mtr"
                                            value={lumpRow.mtr}
                                            onChange={(e) => handleLumpMtr(
                                                lumpIndex,
                                                e.target.value
                                            )}
                                        />
                                    </td>

                                </tr>
                            </>
                        ))}
                        <tr>
                            <td> </td>
                            <td> </td>
                            <td>
                                <span className="tot-lump">Total Lump Mtr</span>
                            </td>
                            <td>
                                <span className="tot-lump">{lumpTotMtr}</span>
                            </td>
                        </tr>
                    </tbody>
                </table>
                <button className="add" onClick={() => handleLumpAddBale()}>Update</button>
            </div>
        </>
    );
}

export default React.memo(LumpMtrTbl);
